import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/Auth/auth.service';

export const sessionGuard: CanActivateFn = (route, state) => {
  return new Promise<boolean>((resolve, reject) => {
    inject(AuthService)
      .validateSession()
      .subscribe({
        next: (value) => {
          resolve(true);
        },
        error: (err) => {
          reject(false);
        },
      });
  });
};
